export const apiConstants = {
    referrerGhostAccountDetails: 'Referral/ReferrerGhostAccountDetails?ghostUId=',
  };